const RELATIVE_TIME_DIVISIONS: {
  amount: number
  unit: Intl.RelativeTimeFormatUnit
}[] = [
  { amount: 60, unit: 'seconds' },
  { amount: 60, unit: 'minutes' },
  { amount: 24, unit: 'hours' },
  { amount: 7, unit: 'days' },
  { amount: 4.34524, unit: 'weeks' },
  { amount: 12, unit: 'months' },
  { amount: Number.POSITIVE_INFINITY, unit: 'years' },
]

export const formatRelativeTime = (
  value?: string | Date | null,
  locale?: string,
) => {
  if (!value) {
    return null
  }

  const date = value instanceof Date ? value : new Date(value)
  const formatter = new Intl.RelativeTimeFormat(locale, {
    numeric: 'auto',
  })

  let duration = (date.getTime() - Date.now()) / 1000

  for (const division of RELATIVE_TIME_DIVISIONS) {
    const roundedDuration = Math.round(duration)

    if (Math.abs(roundedDuration) < division.amount) {
      return formatter.format(roundedDuration, division.unit)
    }

    duration /= division.amount
  }

  return null
}
